module.exports = __webpack_public_path__ + "static/media/kingOfCapot-4.1cea2671.png";